// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useQuery } from '@tanstack/react-query';
import { get } from '@tls/auth';
import { GenericResponse } from 'model/reponse/GenericResponse';
import { Version } from './Version';

export default function useVersionsApi() {
  const {
    data: versions,
    isLoading: loadingVersions,
    refetch: getVersions,
  } = useQuery<GenericResponse<Version[]>>({
    queryKey: ['settings:versions'],
    queryFn: async () => await get('version/all'),
  });

  return { versions: versions?.data, loadingVersions, getVersions };
}
